var PLANETARY_HEALTH_WORKSPACE_ID, Question, W, alt, exportConclusions, exportInterventions, exportIsof, exportJustification, exportJustificationPromise, exportPopulation, exportQuestionAndRecommendation, get, getAssessmentSectionsPromises, getCertaintyOfEvidenceAndLabel, getConclusionsContentPromise, getContentPromise, getEtdPrintout, getHtmlContentFromEpiditorRender, getPromiseOrResolveString, getRecommendationDirectionAndStrength, getRecommendationMetadata, getRecommendationMetadataOrUndefined, getRecommendationText, getRecommendationTextContent, getReferencesFromEpiditorRender, getRemarksContent, getRemarksText, getSofPrintout, gradeProCodeToWHOCode, mediator, processReferencesForExport, renderEditorValue, sanitizeReference, _ref, _ref1;

get = require('lodash').get;

_ref = require('lib/services/covid_exporter/utils'), exportConclusions = _ref.exportConclusions, exportIsof = _ref.exportIsof, exportJustification = _ref.exportJustification, exportJustificationPromise = _ref.exportJustificationPromise, getAssessmentSectionsPromises = _ref.getAssessmentSectionsPromises, getCertaintyOfEvidenceAndLabel = _ref.getCertaintyOfEvidenceAndLabel, getConclusionsContentPromise = _ref.getConclusionsContentPromise, getEtdPrintout = _ref.getEtdPrintout, getHtmlContentFromEpiditorRender = _ref.getHtmlContentFromEpiditorRender, getPromiseOrResolveString = _ref.getPromiseOrResolveString, getRecommendationDirectionAndStrength = _ref.getRecommendationDirectionAndStrength, getRecommendationMetadata = _ref.getRecommendationMetadata, getRecommendationMetadataOrUndefined = _ref.getRecommendationMetadataOrUndefined, getRecommendationText = _ref.getRecommendationText, getRecommendationTextContent = _ref.getRecommendationTextContent, getReferencesFromEpiditorRender = _ref.getReferencesFromEpiditorRender, getRemarksContent = _ref.getRemarksContent, getRemarksText = _ref.getRemarksText, getSofPrintout = _ref.getSofPrintout, gradeProCodeToWHOCode = _ref.gradeProCodeToWHOCode, renderEditorValue = _ref.renderEditorValue;

PLANETARY_HEALTH_WORKSPACE_ID = require('lib/planetary_health_extraction_helper').PLANETARY_HEALTH_WORKSPACE_ID;

getContentPromise = require('lib/services/document_sections_exporter/utils').getContentPromise;

mediator = require('mediator');

alt = require('alt');

_ref1 = require('lib/references_utils'), processReferencesForExport = _ref1.processReferencesForExport, sanitizeReference = _ref1.sanitizeReference;

Question = require('models/question');

W = require('when/when');

exportInterventions = function(question) {
  var interventions, _ref2, _ref3, _ref4, _ref5;
  switch (question.type) {
    case 'diagnostic':
      interventions = [
        {
          '@id': '_:int1',
          '@type': 'WHOIntervention',
          'name': question['indexTest'],
          'codes': _.chain((_ref2 = get(question, 'codes.indexTest')) != null ? _ref2 : {}).values().map(gradeProCodeToWHOCode).value()
        }
      ];
      if (question['comparatorTestPresent']) {
        interventions.push({
          '@id': '_:int2',
          '@type': 'WHOIntervention',
          'name': question['comparatorTest'],
          'codes': _.chain((_ref3 = get(question, 'codes.comparatorTest')) != null ? _ref3 : {}).values().map(gradeProCodeToWHOCode).value()
        });
      }
      return interventions;
    default:
      return [
        {
          '@id': '_:int1',
          '@type': 'WHOIntervention',
          'name': question['intervention'],
          'codes': _.chain((_ref4 = get(question, 'codes.intervention')) != null ? _ref4 : {}).values().map(gradeProCodeToWHOCode).value()
        }, {
          '@id': '_:int2',
          '@type': 'WHOIntervention',
          'name': question['comparison'],
          'codes': _.chain((_ref5 = get(question, 'codes.comparison')) != null ? _ref5 : {}).values().map(gradeProCodeToWHOCode).value()
        }
      ];
  }
};

exportPopulation = function(question, recommendation) {
  var setting, _ref2;
  setting = renderEditorValue(get(recommendation, 'templateData.question.sections.setting.content'));
  if (!setting) {
    setting = question['settings'];
  }
  if (!setting) {
    setting = void 0;
  }
  return [
    {
      '@id': '_:pop1',
      '@type': 'WHOPopulation',
      'ages': _.reject(getRecommendationMetadata(recommendation, 'age'), function(v) {
        return v === 'any';
      }),
      'codes': _.chain((_ref2 = get(question, 'codes.population')) != null ? _ref2 : {}).values().map(gradeProCodeToWHOCode).value(),
      'description': question['healthProblemOrPopulation'],
      'setting': setting
    }
  ];
};

exportQuestionAndRecommendation = function(question, recommendations, projectId) {
  var assessmentPromises, conclusionsPromise, isDiagnostic, isGps, justificationPromise, projectName, questionModel, recommendation, recommendationContent, recommendationId, recommendationTextPromise, relatedEvidenceIds, relatedEvidenceProfiles, remarksContent, remarksPromise;
  projectName = mediator.projects.get(projectId).get('name');
  questionModel = new Question(question);
  isDiagnostic = question['type'] === 'diagnostic';
  isGps = question['type'] === 'good-practice-statement';
  recommendationId = _.first(question['recommendationIds']);
  recommendation = get(recommendations, recommendationId);
  if (!recommendation) {
    return W.resolve();
  }
  remarksContent = getRemarksContent(recommendation);
  remarksPromise = getPromiseOrResolveString(remarksContent, "remarks_" + recommendationId);
  recommendationContent = getRecommendationTextContent(recommendation, isGps);
  recommendationTextPromise = getPromiseOrResolveString(recommendationContent, "recommendation_" + recommendationId);
  relatedEvidenceIds = get(recommendation, 'templateData.relatedEvidenceIds');
  relatedEvidenceProfiles = (relatedEvidenceIds != null ? relatedEvidenceIds.length : void 0) ? relatedEvidenceIds.map(function(id) {
    var evidence, profile, _ref2;
    evidence = alt.stores.PublicationPlatformStore.getState().getIn(['common', 'questions', id], Immutable.Map()).toJS();
    profile = new Question(evidence);
    if (!((_ref2 = profile.get('outcomes')) != null ? _ref2.length : void 0)) {
      return null;
    }
    return {
      name: profile.get('question'),
      isofData: exportIsof(profile, projectName)
    };
  }) : [];
  assessmentPromises = getAssessmentSectionsPromises(recommendation);
  justificationPromise = exportJustificationPromise(recommendation);
  conclusionsPromise = getConclusionsContentPromise(recommendation, ['recommendation', 'goodPracticeStatement']);
  return W.all([recommendationTextPromise, remarksPromise, assessmentPromises, justificationPromise, conclusionsPromise]).then(function(_arg) {
    var allReferenceIds, assessment, certaintyOfEvidence, coexistingConditions, coi, comparison, conclusions, etdPrintoutPromise, fullReferencesData, gradeCertaintyOfEvidenceLabel, interventionDescription, isofData, justification, perspective, plainLanguageSummary, recommendationContent, recommendationDirection, recommendationIntentKey, recommendationStrength, recommendationText, recommendationValue, referenceIds, references, referencesFromTablesIds, remarks, remarksText, sofPrintoutPromise, _ref2, _ref3;
    recommendationContent = _arg[0], remarks = _arg[1], assessment = _arg[2], justification = _arg[3], conclusions = _arg[4];
    _ref2 = getRecommendationDirectionAndStrength(recommendation), recommendationDirection = _ref2[0], recommendationStrength = _ref2[1], recommendationValue = _ref2[2];
    if (justification != null) {
      conclusions['sections']['justification'] = justification;
    }
    interventionDescription = _.compact([question['intervention'], question['comparison']]).join(', ');
    coexistingConditions = _.chain(getRecommendationMetadata(recommendation, 'coexistingCondition', '')[0].split(';')).map(function(value) {
      return _.str.capitalize(value.trim());
    }).compact().value();
    _ref3 = getCertaintyOfEvidenceAndLabel(recommendation), certaintyOfEvidence = _ref3[0], gradeCertaintyOfEvidenceLabel = _ref3[1];
    coi = renderEditorValue(get(recommendation, 'templateData.question.sections.coi.content'));
    if (!coi) {
      coi = void 0;
    }
    perspective = renderEditorValue(get(recommendation, 'templateData.question.sections.perspective.content'));
    if (!perspective) {
      perspective = void 0;
    }
    comparison = question.type === 'diagnostic' && !question.comparatorTestPresent ? void 0 : [
      {
        '@id': '_:int2'
      }
    ];
    isofData = exportIsof(questionModel, projectName);
    plainLanguageSummary = _.reject(getRecommendationMetadata(recommendation, 'plainLanguageSummary'), function(plr) {
      return _.isEmpty(plr.link);
    });
    etdPrintoutPromise = getEtdPrintout(projectId, questionModel, recommendationId);
    sofPrintoutPromise = getSofPrintout(questionModel);
    recommendationText = getHtmlContentFromEpiditorRender(recommendationContent);
    remarksText = getHtmlContentFromEpiditorRender(remarks);
    references = _.map(_.extend({}, remarks, (assessment != null ? assessment.sections : void 0) || {}, (conclusions != null ? conclusions.sections : void 0) || {}), function(section) {
      return section.referenceData || {
        references: [],
        referencesFromTables: [],
        fullReferencesData: []
      };
    }).concat([_.omit(recommendationContent, 'sections'), _.omit(remarks, 'sections')]);
    referenceIds = _.chain(references).pluck('references').flatten().compact().uniq().value();
    referencesFromTablesIds = _.chain(references).pluck('referencesFromTables').flatten().compact().uniq().value();
    allReferenceIds = _.union(referenceIds, referencesFromTablesIds);
    fullReferencesData = _.chain(references).pluck('fullReferencesData').flatten().compact().map(function(ref) {
      return _.map(_.values(ref), sanitizeReference);
    }).flatten().value();
    references = processReferencesForExport(allReferenceIds, fullReferencesData);
    recommendationIntentKey = mediator.activeWorkspace === PLANETARY_HEALTH_WORKSPACE_ID ? 'recommendationModule' : 'recommendationIntent';
    return W.all([etdPrintoutPromise, sofPrintoutPromise]).then(function(_arg1) {
      var etdPrintout, sofPrintout;
      etdPrintout = _arg1[0], sofPrintout = _arg1[1];
      return {
        '@id': question['_id'],
        '@type': 'WHORecommendation',
        'adapted': getRecommendationMetadata(recommendation, 'adapted', false)[0],
        'coexistingCondition': coexistingConditions,
        'diagnostic': isDiagnostic,
        'etdPrintout': etdPrintout,
        'gps': isGps,
        'informal': getRecommendationMetadata(recommendation, 'informal', false)[0],
        'intendedPopulation': getRecommendationMetadata(recommendation, 'intendedPopulation'),
        'intervention': exportInterventions(question),
        'interventionDescription': interventionDescription,
        'isofData': isofData,
        'plainLanguageSummary': plainLanguageSummary,
        'planetaryHealth': getRecommendationMetadata(recommendation, 'planetaryHealth'),
        'population': exportPopulation(question, recommendation),
        'populationDescription': question['healthProblemOrPopulation'],
        'publicationDate': getRecommendationMetadataOrUndefined(recommendation, 'publicationDate'),
        'recommendationIntent': _.union(['all'], getRecommendationMetadata(recommendation, recommendationIntentKey)),
        'references': (references || Immutable.List()).toJS(),
        'relatedEvidenceProfiles': relatedEvidenceProfiles,
        'reportedAsGPS': getRecommendationMetadata(recommendation, 'reportedAsGPS', false)[0],
        'research': getRecommendationMetadata(recommendation, 'research', false)[0],
        'sofPrintout': sofPrintout,
        'transformed': getRecommendationMetadata(recommendation, 'transformed', false)[0],
        'question': [
          {
            '@id': '_:q1',
            '@type': 'WHOQuestion',
            'intervention': [
              {
                '@id': '_:int1'
              }
            ],
            'comparison': comparison,
            'population': [
              {
                '@id': '_:pop1'
              }
            ],
            'gradeCertaintyOfEvidence': certaintyOfEvidence,
            'gradeCertaintyOfEvidenceLabel': gradeCertaintyOfEvidenceLabel,
            'perspective': perspective
          }
        ],
        'recommendation': {
          'coi': coi,
          'direction': recommendationDirection,
          'strength': recommendationStrength,
          'recommendationValue': recommendationValue,
          'assessmentSummary': assessment,
          'conclusions': conclusions,
          'value': recommendationText,
          'remarks': remarksText
        }
      };
    });
  });
};

module.exports = exportQuestionAndRecommendation;
